import { render } from "./padel-login.template.html?vue&type=template&id=419ac634&scoped=true"
import script from "./PadelLogin.vue?vue&type=script&lang=ts"
export * from "./PadelLogin.vue?vue&type=script&lang=ts"

import "./PadelLogin.vue?vue&type=style&index=0&id=419ac634&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-419ac634"

export default script